import React, { ReactElement } from "react";
import clsx from "clsx";

interface IProps {
  onChange: (e: string) => void;
  networkingProfileAbout: string;
  editMode: boolean;
  isUseNetworking: boolean;
  hasError?: boolean;
}

const About = ({
  networkingProfileAbout,
  onChange,
  editMode,
  isUseNetworking,
  hasError = false,
}: IProps): ReactElement => {
  return (
    <div className="profile-netw-step">
      <div
        className={clsx("profile-netw-step__body", {
          "profile-netw-step--error": editMode && hasError,
        })}
      >
        <div className="profile-netw-step__body-header">
          <p className="profile-netw-step__title">
            {isUseNetworking ? "О себе" : "Расскажите о себе"}
          </p>
          {!isUseNetworking && (
            <p className="profile-netw-step__subtitle">
              Расскажите подробнее о вашей деятельности. Сфера деятельности,
              должность, стаж работы и т.д. Этот пункт вы можете заполнить
              потом.
            </p>
          )}
        </div>

        {editMode ? (
          <div className="profile-netw-step__main">
            <div className="textarea">
              <textarea
                className="textarea__input"
                name="about"
                rows={5}
                onChange={(e) => onChange(e.target.value)}
                maxLength={500}
              >
                {networkingProfileAbout}
              </textarea>
              <div className="textarea__counter">
                {networkingProfileAbout?.length || 0} / 500 знаков
              </div>
            </div>
          </div>
        ) : (
          networkingProfileAbout && (
            <div className="profile-netw-step__main">
              {networkingProfileAbout}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default About;
